import React, { useEffect, useState } from "react";

import {
    LineChartOutlined,
    SaveOutlined,
    DeleteOutlined,
    ArrowLeftOutlined,
    UserOutlined
} from "@ant-design/icons";

import {
    canSyncRehabData,
    getActiveRehabProfileId,
    getRehabHistory,
    saveRehabData,
    deleteRehabData
} from "../../api/rehabTracking";

import {
    getPatientProfiles
} from "../../api/patientProfile";


export default function Mrc() {

    const [muscleGroup, setMuscleGroup] =
        useState("gap-vai");

    const [side, setSide] =
        useState("phai");

    const [grade, setGrade] =
        useState("");

    const [note, setNote] =
        useState("");

    const [history, setHistory] =
        useState([]);

    const [loading, setLoading] =
        useState(true);

    const [saving, setSaving] =
        useState(false);

    const [message, setMessage] =
        useState("");

    const [activeProfile, setActiveProfile] =
        useState(null);


    /*
     * NHÓM CƠ / ĐỘNG TÁC
     */
    const muscleGroups = [
        {
            value: "gap-vai",
            label: "Gấp vai"
        },
        {
            value: "dang-vai",
            label: "Dạng vai"
        },
        {
            value: "gap-khuyu",
            label: "Gấp khuỷu"
        },
        {
            value: "duoi-khuyu",
            label: "Duỗi khuỷu"
        },
        {
            value: "gap-co-tay",
            label: "Gấp cổ tay"
        },
        {
            value: "duoi-co-tay",
            label: "Duỗi cổ tay"
        },
        {
            value: "gap-hang",
            label: "Gấp háng"
        },
        {
            value: "dang-hang",
            label: "Dạng háng"
        },
        {
            value: "gap-goi",
            label: "Gấp gối"
        },
        {
            value: "duoi-goi",
            label: "Duỗi gối"
        },
        {
            value: "gap-mu-co-chan",
            label: "Gấp mu cổ chân"
        },
        {
            value: "gap-long-co-chan",
            label: "Gấp lòng cổ chân"
        }
    ];


    /*
     * MỨC CƠ LỰC
     */
    const grades = [
        {
            value: 0,
            title: "0/5",
            description:
                "Không ghi nhận co cơ"
        },
        {
            value: 1,
            title: "1/5",
            description:
                "Có co cơ nhưng chưa tạo được vận động khớp"
        },
        {
            value: 2,
            title: "2/5",
            description:
                "Thực hiện được vận động khi loại bỏ ảnh hưởng của trọng lực"
        },
        {
            value: 3,
            title: "3/5",
            description:
                "Thực hiện được vận động chống lại trọng lực"
        },
        {
            value: 4,
            title: "4/5",
            description:
                "Thực hiện được vận động chống trọng lực và một mức kháng lực"
        },
        {
            value: 5,
            title: "5/5",
            description:
                "Thực hiện được vận động chống lại kháng lực đầy đủ khi đánh giá"
        }
    ];


    /*
     * TÊN NHÓM CƠ
     */
    const getMuscleGroupLabel = (value) => {

        const found =
            muscleGroups.find(
                (item) =>
                    item.value === value
            );


        return (
            found?.label ||
            value ||
            ""
        );
    };


    /*
     * TÊN BÊN
     */
    const getSideLabel = (value) => {

        switch (value) {

            case "phai":
                return "Bên phải";

            case "trai":
                return "Bên trái";

            default:
                return "";
        }
    };


    /*
     * MÔ TẢ ĐIỂM
     */
    const getGradeDescription = (value) => {

        const found =
            grades.find(
                (item) =>
                    item.value ===
                    Number(value)
            );


        return (
            found?.description ||
            ""
        );
    };


    /*
     * FORMAT NGÀY GIỜ
     */
    const formatDateTime = (value) => {

        if (!value) {

            return {
                date: "",
                time: ""
            };
        }


        const dateObject =
            new Date(value);


        if (
            Number.isNaN(
                dateObject.getTime()
            )
        ) {

            return {
                date: "",
                time: ""
            };
        }


        return {

            date:
                dateObject.toLocaleDateString(
                    "vi-VN"
                ),

            time:
                dateObject.toLocaleTimeString(
                    "vi-VN",
                    {
                        hour: "2-digit",
                        minute: "2-digit"
                    }
                )
        };
    };


    /*
     * LOAD HỒ SƠ ĐANG CHỌN
     */
    const loadActiveProfile =
        async () => {

            try {

                if (!canSyncRehabData()) {

                    setActiveProfile(null);

                    return;
                }


                const activeId =
                    getActiveRehabProfileId();


                if (!activeId) {

                    setActiveProfile(null);

                    return;
                }


                const profiles =
                    await getPatientProfiles();


                const found =
                    Array.isArray(profiles)
                        ? profiles.find(
                            (item) =>
                                Number(
                                    item.profile_id
                                ) ===
                                Number(activeId)
                        )
                        : null;


                setActiveProfile(
                    found || null
                );

            } catch (error) {

                console.error(
                    "Không thể tải hồ sơ:",
                    error
                );


                setActiveProfile(null);
            }
        };


    /*
     * LOAD LỊCH SỬ MRC
     */
    const loadHistory =
        async () => {

            setLoading(true);

            setMessage("");


            try {

                if (!canSyncRehabData()) {

                    setHistory([]);

                    setMessage(
                        "Vui lòng đăng nhập để lưu và xem dữ liệu phục hồi chức năng."
                    );

                    return;
                }


                if (!getActiveRehabProfileId()) {

                    setHistory([]);

                    setMessage(
                        "Vui lòng chọn hồ sơ đang theo dõi trước khi sử dụng công cụ."
                    );

                    return;
                }


                const data =
                    await getRehabHistory(
                        "mrc"
                    );


                const formatted =
                    Array.isArray(data)
                        ? data.map(
                            (item) => {

                                const tracking =
                                    item.tracking_data ||
                                    {};


                                const dateTime =
                                    formatDateTime(
                                        item.created_at
                                    );


                                const itemGrade =
                                    Number(
                                        tracking.grade ??
                                        0
                                    );


                                return {

                                    id:
                                        item.health_tracking_id,

                                    muscleGroup:
                                        tracking.muscleGroup ||
                                        tracking.muscle_group ||
                                        "",

                                    muscleGroupLabel:
                                        tracking.muscleGroupLabel ||
                                        getMuscleGroupLabel(
                                            tracking.muscleGroup ||
                                            tracking.muscle_group
                                        ),

                                    side:
                                        tracking.side ||
                                        "",

                                    sideLabel:
                                        tracking.sideLabel ||
                                        getSideLabel(
                                            tracking.side
                                        ),

                                    grade:
                                        itemGrade,

                                    gradeDescription:
                                        tracking.gradeDescription ||
                                        getGradeDescription(
                                            itemGrade
                                        ),

                                    note:
                                        tracking.note ||
                                        "",

                                    date:
                                        tracking.date ||
                                        dateTime.date,

                                    time:
                                        tracking.time ||
                                        dateTime.time
                                };
                            }
                        )
                        : [];


                setHistory(
                    formatted
                );

            } catch (error) {

                console.error(
                    "Không thể tải lịch sử MRC:",
                    error
                );


                setHistory([]);


                setMessage(
                    error?.message ||
                    "Không thể tải lịch sử MRC."
                );

            } finally {

                setLoading(false);
            }
        };


    /*
     * LOAD KHI MỞ TRANG
     */
    useEffect(() => {

        loadActiveProfile();

        loadHistory();

    }, []);


    /*
     * LƯU
     */
    const handleSave =
        async () => {

            if (!canSyncRehabData()) {

                alert(
                    "Vui lòng đăng nhập trước khi lưu dữ liệu."
                );

                return;
            }


            if (!getActiveRehabProfileId()) {

                alert(
                    "Vui lòng chọn hồ sơ đang theo dõi trước."
                );

                return;
            }


            if (
                grade === "" ||
                grade === null ||
                grade === undefined
            ) {

                alert(
                    "Vui lòng chọn mức cơ lực từ 0 đến 5."
                );

                return;
            }


            const gradeNumber =
                Number(grade);


            if (
                Number.isNaN(gradeNumber) ||
                gradeNumber < 0 ||
                gradeNumber > 5
            ) {

                alert(
                    "Mức cơ lực không hợp lệ."
                );

                return;
            }


            const now =
                new Date();


            const trackingData = {

                muscleGroup,

                muscleGroupLabel:
                    getMuscleGroupLabel(
                        muscleGroup
                    ),

                side,

                sideLabel:
                    getSideLabel(
                        side
                    ),

                grade:
                    gradeNumber,

                gradeDescription:
                    getGradeDescription(
                        gradeNumber
                    ),

                note:
                    note.trim(),

                date:
                    now.toLocaleDateString(
                        "vi-VN"
                    ),

                time:
                    now.toLocaleTimeString(
                        "vi-VN",
                        {
                            hour: "2-digit",
                            minute: "2-digit"
                        }
                    )
            };


            setSaving(true);

            setMessage("");


            try {

                await saveRehabData(
                    "mrc",
                    trackingData
                );


                setGrade("");

                setNote("");


                await loadHistory();


                setMessage(
                    "Đã lưu kết quả MRC."
                );

            } catch (error) {

                console.error(
                    "Không thể lưu MRC:",
                    error
                );


                setMessage(
                    error?.message ||
                    "Không thể lưu kết quả MRC."
                );

            } finally {

                setSaving(false);
            }
        };


    /*
     * XÓA
     */
    const handleDelete =
        async (id) => {

            const confirmed =
                window.confirm(
                    "Bạn có chắc muốn xóa kết quả MRC này?"
                );


            if (!confirmed) {
                return;
            }


            try {

                await deleteRehabData(
                    id
                );


                setHistory(
                    (current) =>
                        current.filter(
                            (item) =>
                                Number(item.id) !==
                                Number(id)
                        )
                );


                setMessage(
                    "Đã xóa kết quả MRC."
                );

            } catch (error) {

                console.error(
                    "Không thể xóa MRC:",
                    error
                );


                setMessage(
                    error?.message ||
                    "Không thể xóa kết quả MRC."
                );
            }
        };


    return (

        <div className="max-w-screen-xl mx-auto px-3 md:px-5 pt-16 md:pt-4 pb-10">


            {/* QUAY LẠI */}

            <a
                href="/tienich/phuc-hoi-chuc-nang"
                className="inline-flex items-center text-emerald-600 font-semibold text-sm mb-4"
            >

                <ArrowLeftOutlined className="mr-2" />

                Phục hồi chức năng

            </a>


            {/* HEADER */}

            <div className="bg-gradient-to-r from-pink-600 to-rose-500 rounded-2xl px-5 py-5 md:p-8 text-white">

                <div className="flex items-center">

                    <div className="w-12 h-12 rounded-xl bg-white bg-opacity-20 flex items-center justify-center text-2xl">

                        <LineChartOutlined />

                    </div>


                    <div className="ml-4">

                        <p className="text-[11px] md:text-sm font-semibold opacity-90">

                            PHỤC HỒI CHỨC NĂNG

                        </p>


                        <h1 className="text-[25px] md:text-3xl font-bold">

                            Đánh giá cơ lực MRC

                        </h1>

                    </div>

                </div>


                <p className="text-[14px] md:text-base mt-4 opacity-90 leading-5 md:leading-normal max-w-3xl">

                    Ghi lại mức cơ lực đã được đánh giá từ 0 đến 5 cho từng động tác và theo dõi sự thay đổi theo thời gian.

                </p>

            </div>


            {/* HỒ SƠ */}

            {activeProfile ? (

                <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-4 mt-4">

                    <div className="flex items-center">

                        <div className="w-10 h-10 rounded-full bg-emerald-600 text-white flex items-center justify-center">

                            <UserOutlined />

                        </div>


                        <div className="ml-3">

                            <p className="text-[11px] font-bold text-emerald-700 uppercase">

                                Đang ghi dữ liệu cho

                            </p>


                            <p className="font-bold text-gray-900">

                                {activeProfile.profile_name}

                            </p>


                            {activeProfile.relationship && (

                                <p className="text-xs text-gray-500 mt-0.5">

                                    {activeProfile.relationship}

                                </p>

                            )}

                        </div>

                    </div>

                </div>

            ) : (

                <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 mt-4">

                    <p className="font-semibold text-gray-800 text-sm">

                        Chưa chọn hồ sơ theo dõi

                    </p>


                    <p className="text-[13px] text-gray-600 mt-1">

                        Quay lại trang Phục hồi chức năng để chọn hoặc tạo hồ sơ trước khi lưu dữ liệu.

                    </p>


                    <a
                        href="/tienich/phuc-hoi-chuc-nang"
                        className="inline-block mt-2 text-emerald-600 font-semibold text-sm"
                    >

                        Chọn hồ sơ

                    </a>

                </div>

            )}


            {/* THÔNG BÁO */}

            {message && (

                <div className="bg-gray-50 border rounded-xl px-4 py-3 mt-4 text-[13px] text-gray-600">

                    {message}

                </div>

            )}


            {/* FORM */}

            <div className="bg-white border rounded-2xl p-4 md:p-6 mt-5">


                <h2 className="text-xl md:text-2xl font-bold text-gray-800">

                    Ghi nhận cơ lực

                </h2>


                <p className="text-gray-500 text-sm mt-1">

                    Chọn động tác, bên đánh giá và mức cơ lực đã ghi nhận được.

                </p>


                {/* NHÓM CƠ */}

                <div className="mt-5">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">

                        Động tác đánh giá

                    </label>


                    <select
                        value={muscleGroup}
                        onChange={(e) =>
                            setMuscleGroup(
                                e.target.value
                            )
                        }
                        className="w-full h-12 border rounded-xl px-3 bg-white outline-none focus:border-pink-500"
                    >

                        {muscleGroups.map(
                            (item) => (

                                <option
                                    key={item.value}
                                    value={item.value}
                                >

                                    {item.label}

                                </option>

                            )
                        )}

                    </select>

                </div>


                {/* BÊN */}

                <div className="mt-4">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">

                        Bên đánh giá

                    </label>


                    <select
                        value={side}
                        onChange={(e) =>
                            setSide(
                                e.target.value
                            )
                        }
                        className="w-full h-12 border rounded-xl px-3 bg-white outline-none focus:border-pink-500"
                    >

                        <option value="phai">
                            Bên phải
                        </option>

                        <option value="trai">
                            Bên trái
                        </option>

                    </select>

                </div>


                {/* CHỌN ĐIỂM */}

                <div className="mt-5">

                    <label className="block text-sm font-semibold text-gray-700 mb-3">

                        Mức cơ lực

                    </label>


                    <div className="grid grid-cols-3 md:grid-cols-6 gap-2">

                        {grades.map(
                            (item) => {

                                const selected =
                                    grade !== "" &&
                                    Number(grade) ===
                                        item.value;


                                return (

                                    <button
                                        key={item.value}
                                        type="button"
                                        onClick={() =>
                                            setGrade(
                                                item.value
                                            )
                                        }
                                        className={`h-12 rounded-xl border font-bold ${
                                            selected
                                                ? "border-pink-500 bg-pink-50 text-pink-700"
                                                : "border-gray-200 bg-white text-gray-600"
                                        }`}
                                    >

                                        {item.value}/5

                                    </button>

                                );
                            }
                        )}

                    </div>


                    {grade !== "" && (

                        <div className="bg-pink-50 border border-pink-100 rounded-xl px-4 py-3 mt-4">

                            <p className="font-bold text-pink-700">

                                MRC {grade}/5

                            </p>


                            <p className="text-[13px] text-gray-600 leading-5 mt-1">

                                {getGradeDescription(
                                    grade
                                )}

                            </p>

                        </div>

                    )}

                </div>


                {/* GHI CHÚ */}

                <div className="mt-5">

                    <label className="block text-sm font-semibold text-gray-700 mb-2">

                        Ghi chú

                        <span className="font-normal text-gray-400 ml-1">

                            (không bắt buộc)

                        </span>

                    </label>


                    <textarea
                        value={note}
                        onChange={(e) =>
                            setNote(
                                e.target.value
                            )
                        }
                        placeholder="Ví dụ: đau khi thực hiện, mỏi nhanh..."
                        rows={3}
                        className="w-full border rounded-xl px-3 py-3 outline-none focus:border-pink-500 resize-none"
                    />

                </div>


                {/* LƯU */}

                <button
                    type="button"
                    onClick={
                        handleSave
                    }
                    disabled={
                        saving ||
                        !activeProfile
                    }
                    className="w-full mt-5 h-12 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold disabled:opacity-50 disabled:cursor-not-allowed"
                >

                    <SaveOutlined className="mr-2" />

                    {saving
                        ? "Đang lưu..."
                        : "Lưu kết quả MRC"
                    }

                </button>

            </div>


            {/* LỊCH SỬ */}

            <div className="mt-7">


                <h2 className="text-xl md:text-2xl font-bold text-gray-800">

                    Lịch sử cơ lực

                </h2>


                <p className="text-gray-500 text-sm mt-1">

                    Các kết quả MRC của hồ sơ đang được chọn.

                </p>


                {loading ? (

                    <div className="bg-white border rounded-2xl text-center p-8 mt-4">

                        <p className="text-sm text-gray-500">

                            Đang tải dữ liệu...

                        </p>

                    </div>

                ) : history.length === 0 ? (

                    <div className="bg-white border rounded-2xl text-center p-8 mt-4">

                        <LineChartOutlined className="text-3xl text-gray-300" />


                        <p className="font-semibold text-gray-700 mt-3">

                            Chưa có kết quả

                        </p>


                        <p className="text-sm text-gray-500 mt-1">

                            Kết quả cơ lực của hồ sơ này sẽ xuất hiện tại đây.

                        </p>

                    </div>

                ) : (

                    <div className="space-y-3 mt-4">

                        {history.map(
                            (item) => (

                                <div
                                    key={item.id}
                                    className="bg-white border rounded-2xl p-4"
                                >

                                    <div className="flex items-start justify-between">

                                        <div className="flex-1 pr-3">

                                            <div className="flex flex-wrap gap-2">

                                                <span className="bg-pink-50 text-pink-700 px-3 py-1 rounded-lg font-bold text-sm">

                                                    MRC {item.grade}/5

                                                </span>


                                                <span className="bg-gray-50 text-gray-600 px-3 py-1 rounded-lg text-sm">

                                                    {item.sideLabel}

                                                </span>

                                            </div>


                                            <p className="font-bold text-gray-800 mt-3">

                                                {item.muscleGroupLabel}

                                            </p>


                                            <p className="text-[13px] text-gray-500 leading-5 mt-1">

                                                {item.gradeDescription}

                                            </p>


                                            <p className="text-xs text-gray-400 mt-2">

                                                {item.time} - {item.date}

                                            </p>


                                            {item.note && (

                                                <div className="bg-gray-50 rounded-xl px-3 py-2 mt-3">

                                                    <p className="text-[13px] text-gray-500">

                                                        {item.note}

                                                    </p>

                                                </div>

                                            )}

                                        </div>


                                        <button
                                            type="button"
                                            onClick={() =>
                                                handleDelete(
                                                    item.id
                                                )
                                            }
                                            className="w-10 h-10 rounded-xl bg-red-50 text-red-500 flex items-center justify-center flex-shrink-0"
                                            aria-label="Xóa kết quả MRC"
                                        >

                                            <DeleteOutlined />

                                        </button>

                                    </div>

                                </div>

                            )
                        )}

                    </div>

                )}

            </div>


            {/* LƯU Ý */}

            <div className="bg-pink-50 border border-pink-100 rounded-2xl p-4 mt-7">

                <p className="font-semibold text-gray-800 text-sm">

                    Lưu ý

                </p>


                <p className="text-[13px] text-gray-600 leading-5 mt-1">

                    Công cụ này dùng để ghi lại mức cơ lực đã được đánh giá theo thang MRC từ 0 đến 5.

                </p>


                <p className="text-[13px] text-gray-500 leading-5 mt-2">

                    Kết quả trên website hỗ trợ lưu và theo dõi qua nhiều lần,
                    không tự chẩn đoán nguyên nhân yếu cơ và không thay thế đánh giá trực tiếp của nhân viên y tế.

                </p>

            </div>


        </div>
    );
}